import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "react-feather";
import DocumentUpload from './DocumentUpload';
import UploadHistory from './history/UploadHistory';
import './style.scss';
import DashboardHeader from '../Dashboard/dashboardHeader';

const DocumentForgery = () => {
    const { step } = useParams();
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('1');

    useEffect(() => {
        if (step === 'history') {
            setActiveTab('2');
        } else {
            setActiveTab('1');
        }
    }, [step]);

    return (
        <div className='document-forgery'>
            <div className="header-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
            </div>
            <div className="container-fluid">
                <div>
                    <DocumentUpload />
                </div>
            </div>
        </div>
    );
};

export default DocumentForgery;